import { Title } from "../Types/Title";


export const TitleContent: Title = {
    title: {
        da: "Gustav Weber Kinch",
        en: "Gustav Weber Kinch"
    },
    subtitle: {
        da: "Cand. Polyt. & Senior Architect @ Netcompany",
        en: "Cand. Polyt. & Senior Architect @ Netcompany"
    }
};
